// Put your applicaiton javascript here
(function() {
  // identify an element to observe

  var count = 0;
  const target = document.body

  // Observer's config
  const config = {
    childList: true,
    subtree:true,
  };

  // Observer function 
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {

      //Add attributes to 3rd party popups 
      if (mutation.addedNodes.length){
        if($('#mps-sales-notification').length){
          $('#mps-sales-notification .sn-info-wrapper').attr('aria-live','polite');         
          $('#mps-sales-notification a').attr('aria-label','Sale Notification');
          $('#mps-sales-notification a').attr('role','button');
        }
        if($('#onesignal-slidedown-dialog').length){
          $('#onesignal-slidedown-dialog').attr('hidden', '');
        }
        

        //add title to iframe vimeo videos devtools requirement
        
        if($('iframe[src*="vimeo.com"]').length){

          let vimeoVideos = document.querySelectorAll('iframe[src*="vimeo.com"]')

          var countVideos = 0;
          vimeoVideos.forEach(element => {
            countVideos++ 
            element.setAttribute('title',`Vimeo Video ${countVideos}`);   
          });
        }
        
        //Newsletter Subscription Successful Alert
        if($('.needsclick.klaviyo-form .ql-editor span').length && count == 0){
          setTimeout(() => {
            count++;
            var signUpAlert = document.createElement('p');
            signUpAlert.innerHTML = $('.needsclick.klaviyo-form span').text();
            document.querySelector('footer').prepend(signUpAlert);
            signUpAlert.style.position = "fixed";
            signUpAlert.style.color ="rgba(0,0,0,0)"
            signUpAlert.setAttribute("role", "alert")
            setTimeout(() => {
              signUpAlert.remove();
            }, 2000);
     	  }, 500);  
    	}    
      }
    })
  });
  observer.observe(target, config);



  // SocialMedia Icons Aria-Label
  setTimeout(()=>{
    if($("a[href*='facebook.com']").length){
      $("a[href*='facebook.com']").attr('aria-label','Facebook')
      $("a[href*='facebook.com']").attr('role','button')
    }
    if($('a[href*="instagram.com"]').length){
      $('a[href*="instagram.com"]').attr('aria-label','Instagram')
      $('a[href*="instagram.com"]').attr('role','button')
    }
    if($('a[href*="twitter.com"]').length){
      $('a[href*="twitter.com"]').attr('aria-label','Twitter')
      $('a[href*="twitter.com"]').attr('role','button')
    }
    if($('a[href*="youtube.com"]').length){
      $('a[href*="youtube.com"]').attr('aria-label','Youtube Channel')
      $('a[href*="youtube.com"]').attr('role','button')
    }
    if($('a[href*="pinterest.com"]').length){
      $('a[href*="pinterest.com"]').attr('aria-label','Pinterest')
      $('a[href*="pinterest.com"]').attr('role','button')
    }
  
  //Add attributes to uk-slider-items previous and next buttons automatically 
  	if($('a[uk-slider-item="previous"]').length){
      $('a[uk-slider-item="previous"]').attr('aria-label','Previous');
      $('a[uk-slider-item="previous"]').attr('role','button');
    }
  
    if($('a[uk-slider-item="next"]').length){
        $('a[uk-slider-item="next"]').attr('aria-label','Next');
        $('a[uk-slider-item="next"]').attr('role','button');
    }
  
  if($('a[aria-label*="Apple App"] img').length){
    $('a[aria-label*="Apple"] img').attr('alt','Apple App Store');
  }
  
  if($('a[aria-label*="Google Play"] img').length){
    $('a[aria-label*="Google Play"] img').attr('alt','Google Play Store');
  }
 
  },1000)

// home testimonials slider
var count
var previousButton, nextButton;
var slider, slides, slideDots;
var leftMostSlideIndex = 0; 
// home blog slider
var slideCount
var blogPreviousButton, blogNextButton;
var blogSlider, blogSlides, blogSlideDots;
var leftMostBlogSlideIndex = 0; 
// seach keyboard focus
var searchNav, searchClose;

window.onload = () => {

  searchNav = document.getElementById('search');
  searchClose = document.getElementById('search-close');
  searchClose.addEventListener('click', () => {
    setTimeout(() => {
      searchNav.focus();
      console.log('focused: ', document.activeElement);
    }, 500);
  });

  slider = document.querySelector('.uk-slider-dotnav-one');
  count = 0;
  if(slider) {
    previousButton = slider.querySelector('[uk-slidenav-previous]');
    nextButton = slider.querySelector('[uk-slidenav-next]');
    slides = slider.querySelectorAll('#testimonial-slider li');
    slideDots = slider.querySelectorAll('#testimonial-slider-dotnav a');
  
    // Set up previous/next button behaviors
    previousButton.addEventListener('click', previousSlide);
    nextButton.addEventListener('click', nextSlide);

    // Ensure that all non-visible slides are impossible to reach.
    hideNonVisibleSlides();

    // Set up the slide dot behaviors
    slideDots.forEach((element, index) => {
      count++ 
      element.setAttribute('aria-label',`Go to slide ${count}`);
      element.setAttribute('role','button');
      if (index == 0) {
        element.setAttribute('aria-current', true);
      }
      element.addEventListener('click', function(e) {
        goToSlide(Array.prototype.slice.call(slideDots).indexOf(e.target));
      });
    });
  }

  blogSlider = document.querySelector('.uk-slider-dotnav-three');
  slideCount = 0; 
  if(blogSlider) {
    blogPreviousButton = blogSlider.querySelector('[uk-slidenav-previous]');
    blogNextButton = blogSlider.querySelector('[uk-slidenav-next]');
    blogSlides = blogSlider.querySelectorAll('#blog-slider li');
    blogSlideDots = blogSlider.querySelectorAll('#blog-slider-dotnav a');

    // Set up previous/next button behaviors
    blogPreviousButton.addEventListener('click', previousBlogSlide);
    blogNextButton.addEventListener('click', nextBlogSlide);

    // Ensure that all non-visible slides are impossible to reach.
    hideNonVisibleBlogSlides();

    // Set up the slide dot behaviors
    blogSlideDots.forEach((element, index) => {
      slideCount++
      element.setAttribute('aria-label',`Go to slide ${slideCount}`);
      element.setAttribute('role','button');
      if (index == 0) {
        element.setAttribute('aria-current', true);
      }
      element.addEventListener('click', function(e) {
        goToBlogSlide(Array.prototype.slice.call(blogSlideDots).indexOf(e.target));
      });
    });
  }

};

/** Go to previous slide */
function previousSlide() {
  if(leftMostSlideIndex > 0) {
    goToSlide(leftMostSlideIndex - 1);
  } else {
    goToSlide(slides.length - 1);
  }
}

/** Go to next slide */
function nextSlide() {
  if(leftMostSlideIndex < slides.length - 1) {
    goToSlide(leftMostSlideIndex + 1);
  } else {
    goToSlide(0);
  }
}

/** Go to a specific slide */
function goToSlide(nextLeftMostSlideIndex) {

  // Unset aria-current attribute from any slide dots that have it
  slideDots.forEach(function(dot) {
    dot.removeAttribute('aria-current');
  });
  
  // Set aria-current attribute on the correct slide dot
  slideDots[nextLeftMostSlideIndex].setAttribute('aria-current', true);
  
  // Update the record of the left-most slide
  leftMostSlideIndex = nextLeftMostSlideIndex;
  
  // Update each slide so that the ones that are now off-screen are fully hidden.
  hideNonVisibleSlides();
}

/**
  Fully hide non-visible slides by adding aria-hidden="true" and tabindex="-1" when they go out of view
*/
function hideNonVisibleSlides() {
  // Start by hiding all the slides and their content
  slides.forEach(function(slide) {
    slide.setAttribute('aria-hidden', true);
    
    slide.querySelectorAll('a, button, select, input, textarea, [tabindex="0"]').forEach(function(focusableElement) {
      focusableElement.setAttribute('tabindex', -1);      
    });
  });
  
  // Since we know 3 slides are visible at a time, make sure that the 3 slides starting with the left-most one are not hidden to anybody.
  if(leftMostSlideIndex < slides.length) {
    for(var i = leftMostSlideIndex; i < leftMostSlideIndex + 1; i++) {
      slides[i].removeAttribute('aria-hidden');
      
      slides[i].querySelectorAll('a, button, select, input, textarea, [tabindex="0"]').forEach(function(focusableElement) {
        focusableElement.removeAttribute('tabindex');      
      });
    }
    
  // Since scrolling stops when the carousel reaches the last three slides, we should make sure that these last three slides stay visible until the user wraps or goes backwards.
  } else {
    for(var i = 1; i < slides.length; i++) {
      slides[i].removeAttribute('aria-hidden');
      
      slides[i].querySelectorAll('a, button, select, input, textarea, [tabindex="0"]').forEach(function(focusableElement) {
        focusableElement.removeAttribute('tabindex');      
      });
    }
  }
}

/** Go to previous slide */
function previousBlogSlide() {
  if(leftMostBlogSlideIndex > 0) {
    goToBlogSlide(leftMostBlogSlideIndex - 1);
  } else {
    goToBlogSlide(blogSlides.length - 1);
  }
}

/** Go to next slide */
function nextBlogSlide() {
  if(leftMostBlogSlideIndex < blogSlides.length - 1) {
    goToBlogSlide(leftMostBlogSlideIndex + 1);
  } else {
    goToBlogSlide(0);
  }
}

/** Go to a specific slide */
function goToBlogSlide(nextLeftMostBlogSlideIndex) {

  // Unset aria-current attribute from any slide dots that have it
  blogSlideDots.forEach(function(dot) {
    dot.removeAttribute('aria-current');
  });
  
  // Set aria-current attribute on the correct slide dot
  blogSlideDots[nextLeftMostBlogSlideIndex].setAttribute('aria-current', true);
  
  // Update the record of the left-most slide
  leftMostBlogSlideIndex = nextLeftMostBlogSlideIndex;
  
  // Update each slide so that the ones that are now off-screen are fully hidden.
  hideNonVisibleBlogSlides();
}

/**
  Fully hide non-visible slides by adding aria-hidden="true" and tabindex="-1" when they go out of view
*/
function hideNonVisibleBlogSlides() {
  // Start by hiding all the slides and their content
  blogSlides.forEach(function(slide) {
    slide.setAttribute('aria-hidden', true);
    
    slide.querySelectorAll('a, button, select, input, textarea, [tabindex="0"]').forEach(function(focusableElement) {
      focusableElement.setAttribute('tabindex', -1);      
    });
  });
  
  // Since we know 3 slides are visible at a time, make sure that the 3 slides starting with the left-most one are not hidden to anybody.
  if(leftMostBlogSlideIndex < 6) {
    for(var i = leftMostBlogSlideIndex; i < leftMostBlogSlideIndex + 3; i++) {
      blogSlides[i].removeAttribute('aria-hidden');
      
      blogSlides[i].querySelectorAll('a, button, select, input, textarea, [tabindex="0"]').forEach(function(focusableElement) {
        focusableElement.removeAttribute('tabindex');      
      });
    }
    
  // Since scrolling stops when the carousel reaches the last three slides, we should make sure that these last three slides stay visible until the user wraps or goes backwards.
  } else {
    for(var i = 6; i < 9; i++) {
      blogSlides[i].removeAttribute('aria-hidden');
      
      blogSlides[i].querySelectorAll('a, button, select, input, textarea, [tabindex="0"]').forEach(function(focusableElement) {
        focusableElement.removeAttribute('tabindex');      
      });
    }
  }
}

})();  



